import ItemPerfomancesButtonGroup from '../../forms/fields/ItemPerfomancesButtonGroup'

const ListItemMoviePerformancesEditButton = ({itemData, onUpdate, flyerPk}) => {
    return (
        <div className="item-edit">
            <div className="item-edit-inner">

                {'compact' !== itemData.style && <ItemPerfomancesButtonGroup
                    dataKey='description'
                    transIdDescription="print_flyer_movie_description"
                    flyerPk={flyerPk}
                    itemData={itemData}
                    onUpdate={onUpdate}
                    buttonsConfig={[
                        {
                            "value": "short",
                            "transId": "print_flyer_movie_description_short"
                        }, 
                        {
                            "value": "long",
                            "transId": "print_flyer_movie_description_long"
                        }
                    ]}
                />}

                <ItemPerfomancesButtonGroup
                    dataKey='style'
                    transIdDescription="print_flyer_movie_style"
                    itemData={itemData}
                    onUpdate={onUpdate}
                    flyerPk={flyerPk}
                    buttonsConfig={[
                        {
                            "value":"compact",
                            "transId": "print_flyer_movie_style_compact"
                        }, 
                        {
                            "value":"extended",
                            "transId": "print_flyer_movie_style_extended"
                        },
                        {
                            "value":"single_movie_poster",
                            "transId": "print_flyer_movie_style_single_movie_poster"
                        },
                        {
                            "value":"single_movie_background",
                            "transId": "print_flyer_movie_style_single_movie_background"
                        }
                    ]}
                />

            </div>
        </div>
    )
}

export default ListItemMoviePerformancesEditButton